export default "__VITE_ASSET__CMMKg9ea__"